import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=561a1346"
import script from "./ListLayout.vue?vue&type=script&lang=js"
export * from "./ListLayout.vue?vue&type=script&lang=js"
import style0 from "./ListLayout.vue?vue&type=style&index=0&id=561a1346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports